import { useEffect } from "react";
import { awsRum } from "../../..";
import { RUMPage } from "../../../enums/rum";
import AdminGrid from "../../../components/admin/users";

const AdminPage = () => {
  useEffect(() => {
    try{
      awsRum.recordPageView(RUMPage.ADMIN);
    }
    catch{
      // Swallow rum errors
    }
    
  }, [])
  
  return <AdminGrid />;
};

export default AdminPage;
